
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Order } from "@/orders";

@Component
export class PendingOrders extends Vue {
  @Prop({ required: true }) active!: boolean;
  @Prop({ required: true }) listOrdersPending!: Order[];
  image = require("@/orders/assets/icons/icon-pedidos-entrega-de-cambio.svg");
  imageDown = require("@/orders/assets/icons/icon-chevron-down.svg");
  imagePlus = require("@/orders/assets/icons/icon-icon-icn-plus.svg");
  showPendingPrograming = true;

  closeModal() {
    this.$emit("closeModal");
  }
  closeOrderPending() {
    this.showPendingPrograming = false;
  }
  openOrderPending() {
    this.showPendingPrograming = true;
  }

  openOrderDetail(orderSelected: Order) {
    this.$emit("openOrderDetail", orderSelected);
  }
}
export default PendingOrders;
